export const NULL_REPR: { [key: string]: boolean } = { __superstoreNull: true };
export const NAMESPACE_PREFIX = 'hs.superstore';
export const NAMESPACE_SUFFIX = 'default';
